<div *ngIf="!isLoading">
	<div class="mb-xxxs br-md card">
		<div
			class="d-f fd-c mt-xxxs mb-nano ml-xxxs br-md"
			[formGroup]="userRegistrationForm"
		>
			<div class="d-f ai-c mb-xxs">
				<span class="fs-xs fw-bold lh-xs to-ellipsis">Informações básicas</span>
			</div>
			<div class="d-f line">
				<mat-form-field class="mr-xxxs col-1" title="CPF" appearance="outline">
					<mat-label>CPF</mat-label>
					<input
						type="text"
						matInput
						mask="000.000.000-00"
						placeholder="CPF"
						formControlName="cpf"
						id="spc-{{ inputId }}"
						(blur)="onCpfBlur()"
					/>
					<mat-error
						*ngIf="
							userRegistrationForm.get('cpf')?.hasError('pattern') &&
							!userRegistrationForm.get('cpf')?.hasError('required') &&
							!userRegistrationForm.get('cpf')?.hasError('minlength')
						"
					>
						Digite um CPF válido
					</mat-error>
					<mat-error
						*ngIf="
							userRegistrationForm.get('cpf')?.hasError('minlength') &&
							!userRegistrationForm.get('cpf')?.hasError('pattern') &&
							!userRegistrationForm.get('cpf')?.hasError('required')
						"
					>
						CPF já cadastrado
					</mat-error>
					<mat-error
						*ngIf="userRegistrationForm.get('cpf')?.hasError('required')"
					>
						É necessário digitar o cpf
					</mat-error>
				</mat-form-field>
				<mat-form-field
					class="mr-xxxs col-2 mob-va"
					title="Nome completo"
					appearance="outline"
				>
					<mat-label>Nome Completo</mat-label>
					<input
						type="text"
						matInput
						placeholder="Nome completo"
						formControlName="name"
						id="snf-{{ inputId }}"
					/>
					<mat-error
						*ngIf="userRegistrationForm.get('name')?.hasError('required')"
					>
						Campo obrigatório
					</mat-error>
				</mat-form-field>
			</div>
			<div class="d-f mt-xxs line">
				<mat-form-field
					class="mr-xxxs col-1"
					title="Telefone"
					appearance="outline"
				>
					<mat-label>Telefone</mat-label>
					<input
						type="text"
						matInput
						formControlName="phone"
						id="spp-{{ inputId }}"
						mask="{{ phoneMask(userRegistrationForm.get('phone')?.value) }}"
						placeholder="Telefone"
					/>
					<mat-error
						*ngIf="
							userRegistrationForm.get('phone')?.hasError('pattern') &&
							!userRegistrationForm.get('phone')?.hasError('required')
						"
					>
						Digite um telefone válido
					</mat-error>
					<mat-error
						*ngIf="userRegistrationForm.get('phone')?.hasError('required')"
					>
						Campo obrigatório
					</mat-error>
				</mat-form-field>
				<mat-form-field
					class="mr-xxxs col-2 mob-va"
					title="Email"
					appearance="outline"
				>
					<mat-label>e-Mail</mat-label>
					<input
						type="text"
						matInput
						formControlName="email"
						id="sne-{{ inputId }}"
						placeholder="e-Mail"
						(blur)="onEmailBlur()"
					/>
					<mat-error
						*ngIf="
							userRegistrationForm.get('email')?.hasError('email') &&
							!userRegistrationForm.get('email')?.hasError('required')
						"
					>
						Digite um email válido
					</mat-error>
					<mat-error
						*ngIf="
							userRegistrationForm.get('email')?.hasError('minlength') &&
							!userRegistrationForm.get('email')?.hasError('pattern') &&
							!userRegistrationForm.get('email')?.hasError('required')
						"
					>
						Email já cadastrado
					</mat-error>
					<mat-error
						*ngIf="userRegistrationForm.get('email')?.hasError('required')"
					>
						Campo obrigatório
					</mat-error>
				</mat-form-field>
			</div>
		</div>
	</div>
	<div class="mb-xxxs br-md card">
		<div class="d-f fd-c mt-xxxs mb-nano ml-xxxs br-md">
			<div class="d-f ai-c mb-xxs">
				<span class="fs-xs fw-bold lh-xs to-ellipsis">Organizações</span>
			</div>
			<p class="mr-xxxs mb-xxs">
				Selecione as organizações que usuário terá acesso. Apenas usuários do
				grupo Operadores podem acessar outras organizações
			</p>
			<div class="d-f line">
				<mat-form-field
					title="Organizações"
					appearance="outline"
					class="{{ isDisabledOrganizationModal ? '' : 'c-p' }} col-2"
					(click)="openOrganizationsListModal()"
				>
					<mat-label>Organizações</mat-label>
					<input
						type="text"
						matInput
						placeholder="Organizações"
						id="sol-{{ inputId }}"
						class="{{ isDisabledOrganizationModal ? '' : 'c-p' }}"
						[disabled]="isDisabledOrganizationModal"
						[value]="organizationInput"
						(focus)="opick.focus()"
					/>
					<button
						matSuffix
						mat-icon-button
						aria-label="Open organizations dialog"
					>
						<mat-icon>arrow_drop_down</mat-icon>
					</button>
				</mat-form-field>
				<input #opick type="text" class="picker" />
			</div>
		</div>
	</div>
	<div class="mb-xxxs br-md card">
		<div class="d-f fd-c mt-xxxs mb-nano ml-xxxs br-md">
			<div class="d-f ai-c mb-xxs">
				<span class="fs-xs fw-bold lh-xs to-ellipsis">Grupos de usuários</span>
			</div>
			<p class="mr-xxxs mb-xxs">
				Selecione um grupo ou grupos para esse usuário. Atenção: os grupos de
				admins contêm permissões privilegiadas
			</p>
			<div class="d-f line">
				<mat-form-field
					class="c-p col-2"
					title="Grupos"
					appearance="outline"
					(click)="openOrganizationsGroupsModal()"
				>
					<mat-label>Grupos</mat-label>
					<input
						type="text"
						matInput
						placeholder="Grupos"
						id="sog-{{ inputId }}"
						class="{{ isDisabledGroupModal ? '' : 'c-p' }}"
						[disabled]="isDisabledGroupModal"
						[value]="groupsInput"
						(focus)="gpick.focus()"
					/>
					<button matSuffix mat-icon-button aria-label="Open groups dialog">
						<mat-icon>arrow_drop_down</mat-icon>
					</button>
				</mat-form-field>
				<input #gpick type="text" class="picker" />
			</div>
		</div>
	</div>
	<div class="d-f jc-fe pb-huge mb-xxxs">
		<button
			mat-flat-button
			color="primary"
			[disabled]="userRegistrationForm.invalid"
			(click)="onSubmit()"
		>
			Continuar
		</button>
	</div>
</div>
<div class="d-f jc-c ai-c w-100 mt-giant loader" *ngIf="isLoading">
	<mat-spinner diameter="20"></mat-spinner>
</div>
